module.exports = __webpack_public_path__ + "static/media/calendar.cc6d10c8.svg";